module.exports = __webpack_public_path__ + "static/FoundryGridnik-Medium-5afd213b915a90c8bf75c8a7bffd7659.woff";